export const levels = [
  'Junior High School',
  'Senior High School',
  "Bachelor's",
  "Master's",
  'Doctorate',
]
